import React, { useEffect, useState } from 'react'
import * as styles from './banner.module.scss'

const Banner = () => {

  return (

      <div id='sga-banner' className={styles.sgaBanner}>
        <div className={styles.sgaBannerLeft}>
          <p className={styles.sgaBannerHeading}>Gen4 Joins SGA</p>
          <div className={styles.sgaBannerSubHeadingContainer}>
            <p className={styles.sgaBannerSubHeading}>Expanding scale and opportunity for what's next.</p>
            <a
            href="https://sgadental.com/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.sgaLink}
            >
              Learn More
            </a>
          </div>
        </div>
        <div className={styles.sgaBannerRight}>
          <img
          className={styles.sgaBannerImg}
                src="/sga-dental-logo-1.svg"
                alt="SGA Dental Partners Logo"
              />
        </div>
      </div>

  )
}

export default Banner
